import { QuestionOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Drawer, Space, theme } from 'antd';
import { useState } from 'react';

import { generateSendoutsDrawerText } from '@app/pages/Sendouts/SendoutsList/utils/generateSendoutsDrawerText';

export const SendoutsPageHeader: React.FC = () => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Space>
        <Button icon={<QuestionOutlined />} onClick={showDrawer} />
      </Space>
      <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
        <Drawer
          title="Подсказки к разделу “Рассылки”"
          closable={true}
          onClose={onClose}
          open={open}
        >
          {generateSendoutsDrawerText()}
        </Drawer>
      </ConfigProvider>
    </div>
  );
};
